export default __webpack_public_path__ + "static/media/icon_sign_out_profile2.c323c974.svg";